import { render, staticRenderFns } from "./UpdatingLayout.vue?vue&type=template&id=659fa02c&scoped=true&"
import script from "./UpdatingLayout.vue?vue&type=script&lang=js&"
export * from "./UpdatingLayout.vue?vue&type=script&lang=js&"
import style0 from "./UpdatingLayout.vue?vue&type=style&index=0&id=659fa02c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659fa02c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
